import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import Icon from 'components/DesignSystem/Icon';
import { GenericPreference } from 'types/genericPreference';
import { cssVar } from 'constants/theme';

export default function Preference({
  preference,
  onDelete,
  onSelect,
  deleteLoading,
}: {
  preference: GenericPreference,
  onDelete: () => void,
  onSelect: () => void,
  deleteLoading: boolean,
}) {
  const deleteButtonIcon = deleteLoading ? (
    <Spinner size="sm" />
  ) : (
    <Icon iconType="trash" color={cssVar('text-accent')} />
  );

  return (
    <div className="d-flex flex-row align-items-center">
      <Button
        variant="link"
        onClick={onSelect}
        className="btn-control-panel flex-grow-1"
      >
        { preference.name }
      </Button>
      <Button
        className="btn-preference"
        onClick={onDelete}
        disabled={deleteLoading}
      >
        {deleteButtonIcon}
      </Button>
    </div>
  );
}
